import { useTranslation } from 'react-i18next';

/** Color-coded status badge; falls back to the raw id for unknown statuses. */
export default function StatusPill({ status }: { status: string }) {
  const { t } = useTranslation();
  const key = `status.${status}`;
  const label = t(key);
  return <span className={`status-pill status-pill--${status}`}>{label === key ? status : label}</span>;
}
